<template>
  <div style="position: absolute; left: 0; top:0; right: 0; bottom: 0; width: 100%; height: 100%;">
    <data-card v-for="card in $store.state.cards.cards" :key="card.key" :data="card">
      <template v-slot:title>
        {{card.title}}
      </template>
      <template v-slot:default>
        <component :is="typeComponentMap[card.type]" :item="card"></component>
      </template>
    </data-card>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import DataCard from '@/components/common/DataCard';
import AffiliateCard from '@/components/pages/affiliates/profiles/AffiliateCard';
import PaymentCard from "@/components/pages/payments/PaymentCard";
import MethodCard from '../../pages/methods/MethodCard.vue';

export default {
  name: "DataCardList",
  data() {
    return {
      typeComponentMap: {
        'affiliate': AffiliateCard,
        'payment': PaymentCard,
        'method': MethodCard,
      }
    }
  },
  computed : {
    ...mapGetters('cards', ['maximizedCards'])
  },
  components: {
    DataCard,
    AffiliateCard,
    PaymentCard
  }
}
</script>

<style scoped>

</style>
